<section class="section-padding-home home-divider-light bg-white">
  <div class="container-max">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <span class="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-4">
        Our Portfolio
      </span>
      <h2 class="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
        Featured Projects
      </h2>
      <p class="text-xl text-slate-600 max-w-2xl mx-auto">
        Showcase of our most accomplished projects across residential, commercial, and infrastructure sectors
      </p>
    </div>

    <!-- Featured Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
      <div 
        *ngFor="let project of featuredProjects; let i = index"
        [routerLink]="['/projects', project.id]"
        class="group cursor-pointer"
      >
        <div class="relative overflow-hidden rounded-2xl h-80 mb-6">
          <img 
            [src]="project.image" 
            [alt]="project.title"
            class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          >
          <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
            <div class="text-white">
              <p class="text-sm font-semibold text-primary-300 mb-2">{{ project.category }}</p>
              <h3 class="text-2xl font-bold">{{ project.title }}</h3>
            </div>
          </div>
          <div class="absolute top-4 right-4 px-4 py-2 bg-white/90 backdrop-blur rounded-full text-sm font-semibold text-primary-600">
            {{ project.category }}
          </div>
        </div>
        <h3 class="text-2xl font-bold text-slate-900 mb-2 group-hover:text-primary-600 transition-colors">{{ project.title }}</h3>
        <div class="flex items-center gap-2 text-slate-600 mb-3">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21s-6-5.373-6-10a6 6 0 1112 0c0 4.627-6 10-6 10z"></path>
            <circle cx="12" cy="11" r="2.5" stroke-width="2"></circle>
          </svg>
          {{ project.location }}
        </div>
        <p class="text-slate-600 mb-4">{{ project.description }}</p>
        <span class="inline-flex items-center gap-2 text-primary-600 font-semibold group-hover:gap-3 transition-all">
          View Details
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </span>
      </div>
    </div>

    <!-- CTA -->
    <div class="mt-16 text-center">
      <a 
        routerLink="/projects"
        class="inline-block px-8 py-4 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-bold rounded-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
      >
        View All Projects
      </a>
    </div>
  </div>
</section>
